import { TaggedError } from "@for-it/domain-lib";
export class TenantNotFoundError extends TaggedError {
    constructor() {
        super("TenantNotFoundError");
    }
}
